module.exports = __webpack_public_path__ + "img/cover-minigame-bg-mobile.696065fa.jpg";